// @ts-nocheck

import { BoomStateActionTypes } from '../types/actions/boom';

export const updateBoomUserState = ({ userStateMutation }) => ({
  type: BoomStateActionTypes.UPDATE_STATE,
  payload: {
    userStateMutation,
  },
});

export const claimBoomReward = ({ uuid }) => ({
  type: BoomStateActionTypes.CLAIM_REWARD,
  payload: {
    uuid,
  },
});

export const flushNotifications = () => ({
  type: BoomStateActionTypes.FLUSH_NOTIFICATIONS,
});

export const skipCurrentTemporaryNotification = () => ({ type: BoomStateActionTypes.SKIP_CURRENT_TMP_NOTIFICATION });

export const fillTemporaryBoomNotification = () => ({ type: BoomStateActionTypes.FILL_TEMPORARY_NOTIFICATIONS });

export const registerBoomAdventure = (hooks) => ({
  type: BoomStateActionTypes.REGISTER,
  hooks,
});
